// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_1lySn2AI-71zMRZNt2S-BD"};